/* eslint-disable */
import { useState } from "react";
import TextField from "@mui/material/TextField";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "../common/components/LocalizationProvider";
import AwaitDialog from "../common/components/AwaitDialog";
import SuccessDialog from "../common/components/SuccessDialog";
import { useEffectAsync } from "../reactHelper";
import SettingsMenu from "./components/SettingsMenu";
import EditItemView from './components/EditItemView';
import { errorsActions } from "../store";
import useSettingsStyles from './common/useSettingsStyles';

const WhatsappPage = () => {
  const { classes } = useSettingsStyles();
  const t = useTranslation();
  const dispatch = useDispatch();

  const server = useSelector((state) => state.session.server);

  const [awaiting, setAwaiting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [reconfigure, setReconfigure] = useState(false);
  const [starting, setStarting] = useState(false);
  const [started, setStarted] = useState(false);

  const [qrImage, setQrImage] = useState("/images/whatsapp/loading.gif");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  useEffectAsync(async () => {
    const intervalId = setInterval(async () => {
      const baseUrl = server.attributes.wpp_url;
      const apiKey = server.attributes.wpp_apiKey;
      const sessionId = server.attributes.wpp_sessionId;

      if (!started) {
        if (baseUrl && apiKey && sessionId) {
          const responseStatus = await fetch(
            `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/qrcode`
          );

          if (responseStatus.ok) {
            const resultStatus = await responseStatus.json();
            if (
              resultStatus.message === "O usuário já está logado no sistema"
            ) {
              setQrImage("/images/whatsapp/online.png");
              setStarted(true);
              setStarting(false);
              setReconfigure(false);
            } else if (resultStatus.message === "QRcode buscado") {
              setQrImage(resultStatus.qrcode);
              setStarting(false);
              setReconfigure(false);
            } else {
              setQrImage("/images/whatsapp/offline.png");
              setStarted(false);
              setStarting(false);
              setReconfigure(false);
            }
          } else {
            if (!reconfigure) {
              await handleReconfigure();
            } else {
              if (!starting) {
                await handleStart();
              } else {
                const responseQR = await fetch(
                  `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/qrcode`
                );

                if (responseQR.ok) {
                  const result = await responseQR.text();
                  setQrImage(result.qrcode);
                }
              }
            }
          }
        } else {
          setQrImage("/images/whatsapp/exclamation.png");
        }
      }
    }, 5000);
    return () => clearInterval(intervalId);
  }, [server]);

  const handleReconfigure = async () => {
    const baseUrl = server.attributes.wpp_url;
    const apiKey = server.attributes.wpp_apiKey;
    const sessionId = server.attributes.wpp_sessionId;

    const response = await fetch(
      `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/reconfigurar`,
      { method: "DELETE" }
    );

    if (response.ok) {
      setTimeout(() => {
        setQrImage("/images/whatsapp/loading.gif");
        setStarted(false);
        setReconfigure(true);
        setStarting(false);
      }, "5000");
    }
  };

  const handleStart = async () => {
    const baseUrl = server.attributes.wpp_url;
    const apiKey = server.attributes.wpp_apiKey;
    const sessionId = server.attributes.wpp_sessionId;

    const response = await fetch(
      `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/run`,
      { method: "POST" }
    );

    if (response.ok) {
      const result = await response.json();
      if (result.message === "Instância iniciada com sucesso!") {
        setTimeout(() => {
          setQrImage("/images/whatsapp/loading.gif");
          setReconfigure(true);
          setStarting(true);
          setStarted(false);
        }, "5000");
      }
    }
  };

  const handleSend = async () => {
    setAwaiting(true);
    const baseUrl = server.attributes.wpp_url;
    const apiKey = server.attributes.wpp_apiKey;
    const sessionId = server.attributes.wpp_sessionId;

    if (baseUrl && apiKey && sessionId) {
      if (phone && message) {
        const response = await fetch(
          `${baseUrl}/${sessionId}/rest/instancia/${apiKey}/send`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              phone,
              message,
            }),
          }
        );

        if (response.ok) {
          setPhone("");
          setMessage("");
          setAwaiting(false);
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
          }, "3000");
        } else {
          setAwaiting(false);
          dispatch(errorsActions.push(await response.text()));
        }
      } else {
        setAwaiting(false);
        dispatch(errorsActions.push(`${t("fieldRequired")}`));
      }
    } else {
      setAwaiting(false);
      dispatch(errorsActions.push(`${t("errorTitle")} ${t("serverTitle")}`));
    }
  };

  const handleRestart = async () => {
    try {
      setQrImage("/images/whatsapp/loading.gif");
      await handleReconfigure();
    } catch (error) {
      dispatch(errorsActions.push(error.message));
    }
  };

  // Dummy item and functions for EditItemView compatibility
  const [item] = useState({});
  const validate = () => true;

  return (
    <EditItemView
      endpoint="server"
      item={item}
      setItem={() => {}}
      validate={validate}
      menu={<SettingsMenu />}
      breadcrumbs={["userAdmin", "sharedWhatsapp"]}
      disableSaveButton
    >
      {item && (
        <>
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center" gap={1}>
                <NewReleasesIcon color="primary" />
                <Typography variant="subtitle1">
                  Aponte seu celular para essa tela para capturar o código.
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Box display="flex" flexDirection="column" gap={3}>
                {/* Primeira linha - QR Code e Formulário de Envio */}
                <Box
                  display="flex"
                  gap={2}
                  sx={{ flexDirection: { xs: "column", sm: "row" } }}
                >
                  {/* QR Code */}
                  <Box flex={1} minWidth={0}>
                    <Box sx={{ mb: 2 }}>
                      <img
                        src={qrImage}
                        alt="WhatsApp QR Code"
                        style={{
                          width: "100%",
                          height: "auto",
                          maxWidth: "300px",
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Formulário de Envio */}
                  <Box flex={2} minWidth={0} display="flex" flexDirection="column" gap={2}>
                    <Typography variant="subtitle1">
                      {t("whatsappSendMessage")}
                    </Typography>

                    {/* Telefone e Mensagem em layout responsivo */}
                    <Box
                      display="flex"
                      flexDirection="column"
                      gap={2}
                      width="100%"
                    >
                      <Box
                        display="flex"
                        gap={2}
                        sx={{ flexDirection: { xs: "column", sm: "row" } }}
                      >
                        <Box flex={1} minWidth={0}>
                          <TextField
                            fullWidth
                            value={phone || ""}
                            type="number"
                            onChange={(event) => setPhone(event.target.value)}
                            label={t("sharedWhatsapp")}
                          />
                        </Box>
                        <Box flex={1} minWidth={0} />
                        <Box flex={1} minWidth={0} />
                      </Box>

                      <Box width="100%">
                        <TextField
                          fullWidth
                          value={message || ""}
                          rows={3}
                          multiline
                          onChange={(event) => setMessage(event.target.value)}
                          label={t("commandMessage")}
                          maxRows={3}
                        />
                      </Box>

                      <Box
                        display="flex"
                        gap={2}
                        sx={{ flexDirection: { xs: "column", sm: "row" } }}
                      >
                        <Button
                          type="button"
                          color="primary"
                          variant="outlined"
                          onClick={() => handleSend()}
                        >
                          {t("commandSend")}
                        </Button>
                        <Button
                          type="button"
                          color="primary"
                          variant="contained"
                          onClick={handleRestart}
                        >
                          {`${t("sharedRestart")} QR`}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        </>
      )}
      <AwaitDialog style={{ transform: "none" }} open={awaiting} />
      <SuccessDialog style={{ transform: "none" }} open={success} />
    </EditItemView>
  );
};

export default WhatsappPage;
